import Multiselect from "vue-multiselect";
import axios from "axios";
import debounce from "lodash/debounce";

export const election2023HomeMixin = {
  components: {
    Multiselect,
  },
  data: {
    acResult: [],
  },
  beforeMount: function () {},
  methods: {
    autocomplete: debounce(function (topic) {
      if (topic) {
        var req = {
          term: topic,
        };
        const _self = this;
        axios
          .get("https://elections.lalr.co/api/r/2023/ac", {
            params: req,
          })
          .then(
            function (response) {
              _self.acResult = response.data.locations;
            },
            function (response) {},
          );
      } else {
        this.acResult = [];
      }
    }, 200),
    selectOpt: function (opt) {
      window.location.href = opt.url;
    },
  },
};
